import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Pipeline, Pipe } from 'smart-react';
import RoutesItems from '../Routes/RoutesItems';
import { getRouteMeta } from '../Utils/Routes/routeMeta';
/**
 * Base Layout to attach context prover
 * @param {React.Component} Component
 * @returns {React.Component} Component
 */
const BaseLayoutHOC = (Component) => (props) => {
  const { pathname } = useLocation();
  const routeMeta = getRouteMeta(pathname, RoutesItems);
  const route = routeMeta?.matchedRoute || {}; // Return active route object

  const provider = []; // contain context proivders

  /**
   * Wrap context provider on specified Routes
   */
  if (route?.context) {
    const contextLength = route?.context?.length;
    route?.context.map((ct, i) => {
      const ContextProvider = ct;
      provider[i] = <ContextProvider children={<Pipe />} />;
    });
    provider[contextLength] = <>{<Outlet />} </>;
  }
  const children =
    provider.length > 0 ? <Pipeline components={provider} /> : <Outlet />;
  return (
    <Component
      go_back={route?.go_back}
      go_back_link={route?.go_back_link}
      title={routeMeta?.title}
      eyebrow={routeMeta?.eyebrow}
      description={routeMeta?.description}
      breadcrumbs={routeMeta?.breadcrumbs}
      children={children}
      {...props}
    />
  );
};

export default BaseLayoutHOC;
